import React from "react";

import { env } from "~/env";

export const ContactInfo = () => {
  return (
    <p className="text-gray-600">
      Need assistance booking? Text{" "}
      <a
        href={`tel:${env.VITE_SUPPORT_PHONE_NUMBER_RAW}`}
        className="cursor-pointer text-neutral-950 underline"
      >
        {env.VITE_SUPPORT_PHONE_NUMBER}
      </a>
    </p>
  );
};
